// 公共方法
import moment from 'moment';
import type { AxiosRequestConfig } from 'axios';
import type { MomentInput } from 'moment';
import type { IGameItemDto } from '@dbl/services/global';
import { LOCAL_STROAGE_GAME_CODE_KEY, DATALAB_ADMIN } from '@dbl/core/global';
import { storage } from '@/utils/utils';

export const INSTANCE_CONFIG: AxiosRequestConfig = {
  baseURL: '/',
  method: 'post',
  withCredentials: true,
  timeout: 50000,
  maxContentLength: 5 * 1000 * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus(status) {
    return true;
  },
  // options: {},
};

/**
 * 通过url入参对象，返回页面需要的 edition_unified_id id_type entity_type
 * @param data url路径带参的对象
 * @returns
 */
export function getUrlData(data: {
  entity_type: string;
  id_type?: string;
  unified_edition_id: string;
  mobile_edition_id?: string;
}) {
  let edition_unified_id;
  let id_type;
  let entity_type;
  if (data.entity_type === 'mobile') {
    if (data.id_type === 'unified_id' || data.unified_edition_id === data.mobile_edition_id) {
      edition_unified_id = data.unified_edition_id;
      id_type = 'unified_id';
    } else {
      edition_unified_id = data.mobile_edition_id || data.unified_edition_id;
      id_type = 'edition_id';
    }
    entity_type = 'mobile';
  } else {
    entity_type = data.entity_type;
    edition_unified_id = data.unified_edition_id;
    id_type = 'edition_id';
  }
  return {
    edition_unified_id,
    id_type,
    entity_type,
  };
}
// 获取全局的参数对象
export function handleGlobalParams() {
  const sessionGameInfo = JSON.parse(localStorage.getItem('OpinionGameInfo') || '{}');
  const info = {
    edition_unified_id: '',
    id_type: '',
    entity_type: '',
  };
  if (JSON.stringify(sessionGameInfo) == '{}') {
  } else {
    const GameInfoData = getUrlData(sessionGameInfo);
    info.edition_unified_id = GameInfoData.edition_unified_id;
    info.id_type = GameInfoData.id_type;
    info.entity_type = GameInfoData.entity_type;
  }
  return info;
}
/**
 * sentiment 转换 规则 1=> 4 5 ，2=> 3 , 3=> 2,1
 * 原因：筛选器回传的数组是[1,2,3] 而api接口需要的参数是[5,4,3,2,1]
 * @param arr
 * @returns
 */
export function transSentiment(arr: number[]) {
  const transArr = [];
  if (arr) {
    arr.map((v) => {
      if (v === 1) {
        transArr.push(4, 5);
      }
      if (v === 2) {
        transArr.push(3);
      }
      if (v === 3) {
        transArr.push(1, 2);
      }
    });
  }
  return transArr;
}

// 获取全局的用户user_id
export function getSessionGlobalUserId() {
  // 203 为本地开发使用，开发环境自动登录，不会存userID
  const sessionUserInfo = localStorage.getItem('userID') || '203';
  return sessionUserInfo;
}

export function getV2SessionGlobalUserId() {

  // 203 为本地开发使用，开发环境自动登录，不会存userID
  const sessionUserInfo = storage.getItem(LOCAL_STROAGE_GAME_CODE_KEY);
  const userId = sessionUserInfo?.userId  || '203';
  return userId;
}


/**
 * 单位处理
 * @param value
 * @param intNoDot:整数是否去掉小数点
 * @returns
 */
export function getShowCount(value: number, intNoDot: Boolean) {
  if (isNaN(Number(value))) {
    return value;
  }
  let res = null;
  if (value >= 1000000000) {
    const sen = value / 1000000000;
    res = `${sen.toFixed ? sen.toFixed(2) : sen}B`;
  } else if (value >= 1000000) {
    const sen = value / 1000000;
    res = `${sen.toFixed ? sen.toFixed(2) : sen}M`;
  } else if (value >= 1000) {
    const sen = value / 1000;
    res = `${sen.toFixed ? sen.toFixed(2) : sen}K`;
  } else {
    res = value.toFixed ? value.toFixed(2) : value;
  }
  // 整数去掉小数点
  if (intNoDot && typeof res === 'string' && res.indexOf('.00') !== -1) {
    res = res.replace('.00', '');
  }
  return res !== null ? res : value;
}
// 数组去重
export function deleteArray(arr1: any[], arr2: any[]) {
  let a;
  let b;
  for (let i = arr1?.length - 1;i >= 0;i--) {
    a = arr1[i];
    for (let j = arr2?.length - 1;j >= 0;j--) {
      b = arr2[j];
      if (a == b) {
        arr1.splice(i, 1);
        arr2.splice(j, 1);
        break;
      }
    }
  }
  return arr1 || [];
}


/**
 * 使用match方法实现模糊查询
 * @param  {Array}  list     进行查询的数组
 * @param  {String} keyWord  查询的关键词
 * @return {Array}           查询的结果
 */
export function fuzzyQuery(list: string[], keyWord: string) {
  const arr: any = [];
  for (let i = 0;i < list.length;i++) {
    if (list[i].match(keyWord) != null) {
      arr.push(list[i]);
    }
  }
  return arr;
}

/**
 * 前端分页处理
 */
export function pagingOption(pageIndex: number, pageSize: number, dataList: never[]) {
  return new Promise((resolve) => {
    setTimeout(
      () =>
        resolve({
          records: getTableData(pageIndex, pageSize, dataList),
        }),
      2000,
    );
  });
}

/**
 * @name  getTableData
 * @desc  纯JS前端分页方法
 * @param  {Number} page 当前页码，默认1
 * @param  {Number} pageSize 每页最多显示条数，默认10
 * @param  {Array} totalData 总的数据集，默认为空数组
 * @return {Object} {
    data, //当前页展示数据，数组
    page, //当前页码
    pageSize, //每页最多显示条数
    length, //总的数据条数
  }
**/
const getTableData = (page: number, pageSize: number, totalData: never[]) => {
  const { length } = totalData;
  const tableData = {
    data: [],
    page,
    pageSize,
    length,
  };
  if (pageSize >= length) {
    // pageSize大于等于总数据长度，说明只有1页数据或没有数据
    tableData.data = totalData;
    tableData.page = 1; // 直接取第一页
  } else {
    // pageSize小于总数据长度，数据多余1页
    const num = pageSize * (page - 1); // 计算当前页（不含）之前的所有数据总条数
    if (num < length) {
      // 如果当前页之前所有数据总条数小于（不能等于）总的数据集长度，则说明当前页码没有超出最大页码
      const startIndex = num; // 当前页第一条数据在总数据集中的索引
      const endIndex = num + pageSize - 1; // 当前页最后一条数据索引
      tableData.data = totalData.filter((_, index) => index >= startIndex && index <= endIndex); // 当前页数据条数小于每页最大条数时，也按最大条数范围筛取数据
    } else {
      // 当前页码超出最大页码，则计算实际最后一页的page，自动返回最后一页数据
      const size = Math.floor(length / pageSize); // 取商
      const rest = length % pageSize; // 取余数
      if (rest > 0) {
        // 余数大于0，说明实际最后一页数据不足pageSize，应该取size+1为最后一条的页码
        tableData.page = size + 1; // 当前页码重置，取size+1
        tableData.data = totalData.filter((_, index) => index >= pageSize * size && index <= length);
      } else if (rest === 0) {
        // 余数等于0，最后一页数据条数正好是pageSize
        tableData.page = size; // 当前页码重置，取size
        tableData.data = totalData.filter((_, index) => index >= pageSize * (size - 1) && index <= length);
      } // 注：余数不可能小于0
    }
  }
  return tableData;
};

/**
 * 设置游戏参数
 * @param end_time 时间
 * @param time_type 时间类型
 * @returns
 */
type TimeType = 'hourly' | 'daily' | 'weekly' | 'monthly';
export function changeEndTime(end_time: MomentInput, time_type: TimeType) {
  if (time_type == 'hourly') {
    return moment(end_time).format('YYYY-MM-DD HH:mm:ss');
  }
  if (time_type == 'daily') {
    return moment(end_time).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss');
  }
  if (time_type == 'weekly') {
    return moment(end_time).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss');
  }
  if (time_type == 'monthly') {
    return moment(end_time).add(1, 'M').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss');
  }
}

// 计算日期差
/** *
 * ps 只选择一天或者一个星期或者一个月时使用
 * @param dateArry 日期数组
 * @param timeType 当前日期类型
 * @returns granularity
 */
export function dateDiff(dateArry: [MomentInput, MomentInput], timeType: TimeType) {
  const start_date = moment(dateArry[0]).min(0).seconds(0);
  const end_date = moment(changeEndTime(dateArry[1], timeType));
  const dateDiffs = end_date.diff(start_date, 'day');
  const ledateDiffs = end_date.diff(start_date, 'hour');
  let granularity = 'hourly';
  if (timeType === 'daily' || timeType === 'hourly') {
    granularity = ledateDiffs <= 24 ? 'hourly' : timeType;
  } else if (timeType === 'weekly') {
    granularity = dateDiffs <= 6 ? 'daily' : timeType;
  } else {
    granularity = dateDiffs <= 30 ? 'weekly' : timeType;
  }
  return granularity;
}

// channel一分三
export function getSubChannelValue(list: string[]) {
  const arr: any = { data1: [], data2: [], data3: [] };
  for (let i = 0;i < list.length;i++) {
    const channel = list[i].substring(0, list[i].indexOf('@'));
    // console.log(channel);
    if (channel === 'social') {
      arr.data1.push(list[i].substring(list[i].indexOf('@') + 1, list[i].length));
    }
    if (channel === 'comments') {
      arr.data2.push(list[i].substring(list[i].indexOf('@') + 1, list[i].length));
    }
    if (channel === 'news') {
      arr.data3.push(list[i].substring(list[i].indexOf('@') + 1, list[i].length));
    }
  }
  // console.log(arr)
  return arr;
}

/**
 * 筛选器数据格式化处理
 * @param data 筛选器数据
 * @param gameInfo 游戏info
 * @returns api请求所需入参
 */

export function getFilterdata(data: Record<string, any>, gameInfo: Record<string, any>) {
  if (data.channel_all !== true && JSON.stringify(data.channel_all) !== JSON.stringify([1, 1, 1])) {
    data.channel_all = false;
  }

  let reviewsRating = [];
  let monitorScource = [];
  let platform = [];
  if (gameInfo.entity_type === 'mobile') {
    reviewsRating = data.reviews_rating_all ? [] : data.reviews_rating;
  }
  if (gameInfo.entity_type === 'pc') {
    reviewsRating = data.reviews_rating_pc_all ? [] : data.reviews_rating_pc;
    monitorScource = data.monitor_scource_all ? [] : data.monitor_scource;
  }
  if (gameInfo.entity_type === 'console') {
    reviewsRating = data.reviews_rating_pc_all ? [] : data.reviews_rating_pc;
    monitorScource = data.monitor_scource_all ? [] : data.monitor_scource;
    platform = data.platform_all ? [] : data.platform;
  }

  const keywordData: Array<string> = replaceKeywords(data.keyword);
  // const keyworkKey = ['Common', 'Customized', 'Buzzword']
  // for (let item of data.keyword || []) {
  //   for (let key of keyworkKey) {
  //     if (item.includes(key)) {
  //       keywordData.push(item.replace(`${key}-`, ''))
  //       break
  //     }
  //   }
  // }
  return {
    channel_social: data.channel_all ? ['9999'] : getSubChannelValue(data.channel).data1,
    channel_comments: data.channel_all ? ['9999'] : getSubChannelValue(data.channel).data2,
    channel_news: data.channel_all ? ['9999'] : getSubChannelValue(data.channel).data3,
    language: data.language_all ? [] : data.language,
    sentiment: data.sentiment_all ? [] : transSentiment(data.sentiment),
    social_media_by_keyword: data.social_media_by_keyword,
    social_media_by_account: data.social_media_by_account,
    purpose: data.purpose_all ? [] : data.purpose,
    is_valid: data.is_valid_all ? [] : data.is_valid,
    keyword: data.keyword_all ? [] : keywordData,
    region: data.region[0] === 'GLOBAL' ? [] : data.region,
    region_type: data.region_type,
    topic: data.topic_all ? [] : data.topic,
    start_time: moment(data.currentTime[0]).second(0).minute(0).format('YYYY-MM-DD HH:mm:ss'),
    end_time: changeEndTime(data.currentTime[1], data.dateType),
    // date_type: dateDiff(data.currentTime,data.dateType),
    date_type: data.dateType,
    version: data.version_all ? [] : data.version,
    reviews_rating: reviewsRating,
    monitor_scource: monitorScource,
    platform,
    version_time: data.version_time,
  };
}

/**
 * 对个别channel进行一个翻译
 * @param key 需要转译的channel字段
 * @returns 转译后的
 */
export function transChannel(key: string) {
  const channel: Record<string, string> = {
    youtube_keyword: 'Youtube',
    google_keyword: 'Google News',
  };
  if (channel[key]) {
    return channel[key];
  }
  return key;
}

/**
 * 去除keyword组件中key
 * @param list
 * @returns
 */
export function replaceKeywords(list: any): Array<string> {
  const keywordData: Array<string> = [];
  const keyworkKey = ['Common', 'Customized', 'Buzzword'];
  for (const item of list || []) {
    let flag = true;
    for (const key of keyworkKey) {
      if (item.includes(key)) {
        keywordData.push(item.replace(`${key}-`, ''));
        flag = false;
        break;
      }
    }
    if (flag) {
      keywordData.push(item);
    }
  }
  return keywordData;
}

export const k: number = Math.pow(10, 3); // 1000
export const m: number = Math.pow(10, 6); // 1百万
export const b: number = Math.pow(10, 9); // 10亿
/**
 * 去除keyword组件中key
 * @param target 传进来的目标值
 * @returns object 返回initUnit目标值所在单位内区间的单位  和initData返回目标值所在单位内区间的 四舍五入后的值
 */
// 获取单位 被单位整除单位后的值 和对应的单位
export const getUnitData = (target: number): object => {
  // 处理柱状图的单位转换问题
  let initUnit = ''; // 单位
  let initData = 0; // 在当前单位返回内值(被除单位后的)
  if (m > target && target >= k) {
    initUnit = 'K';
    initData = target / k;
  } else if (b > target && target >= m) {
    initUnit = 'M';
    initData = target / m;
  } else if (target >= b) {
    initUnit = 'B';
    initData = target / b;
  } else if (k > target) {
    initUnit = '';
    initData = target;
  }
  return { initUnit, initData: initData.toFixed(2) }; // 四舍五入
};

/**
 * 去除keyword组件中key
 * @param target 传进来的目标值
 * @param currentUnit 传进来的值 当前单位
 * @param currentUnit 传进来的目标值 要转化成的目标单位
 * @returns initData  传进来的目标值转化成目标单位后的总数
 */
export const getDataByUnit = (target: number, currentUnit: string, targetUnit: string): number => {
  // 处理柱状图的单位转换问题
  let initData = 0;
  if (currentUnit === 'B' && targetUnit === 'M') {
    // 十亿转化为百万
    initData = target * k;
  } else if (currentUnit === 'B' && targetUnit === 'K') {
    // 亿转化为K
    initData = target * m;
  } else if (currentUnit === 'B' && targetUnit === '') {
    // 十转化为少于1000的
    initData = target * b;
  } else if (currentUnit === 'M' && targetUnit === 'K') {
    // 百万转化为K
    initData = target * k;
  } else if (currentUnit === 'M' && targetUnit === '') {
    // 百万转化为少于1000的
    initData = target * m;
  }
  return initData;
};

/**
 * 从gamelist查询当前game
 * @param gameCode 传进来的gamecode
 * @param gameList 传进来的gameList数组
 * @returns currentGame  查找到的game
 */
export const getCurrentGameFromList = (
  gameCode: string,
  gameList: IGameItemDto[],
) => {
  if (!gameCode) {
    return null;
  }
  let currentGame: any = null;
  (gameList || []).some((item: any) => {
    if (item?.game_List && item?.game_List.length > 0) {
      return (item?.game_List || []).some((sItem: any) => {
        if (sItem?.game_code === gameCode) {
          currentGame = sItem;
        }
        return sItem?.game_code === gameCode;
      });
    }
    if (item?.game_code === gameCode) {
      currentGame = item;
    }
    return item?.game_code === gameCode;
  });
  return currentGame;
};

/**
 * 查询本地保存的gamecode
 * @returns gameCode  查找到的gameCode
 */
export const getGameCodeFromLocal = () => {
  const info = storage.getItem(LOCAL_STROAGE_GAME_CODE_KEY) || {};
  // const openid = window.sessionStorage.getItem('openId');
  // if (!openid || !info.openid) {
  //   return '';
  // }
  return info.code || '';
};

export const ERROR_CODE_MESSAGE: Record<number, string> = {
  999: '系统错误',
};

export const isDataLabAdmin = (currentGame?: IGameItemDto | null) =>
  currentGame?.role_id && currentGame?.role_id?.includes(DATALAB_ADMIN);



export const getTimeRange = (timeRangeInit:Array<string>,timeType:string)=>{
  let timeRange = timeRangeInit;
  const type = timeType?.toLowerCase();
  if(type === 'day' || type === 'date' || type ==='aggregate') {
    timeRange = timeRange;
  } else if (type === 'week') {
    timeRange = [moment(timeRangeInit?.[0]).weekday(0).format('YYY-MM-DD'), moment(timeRangeInit?.[1]).weekday(6).format('YYY-MM-DD')];
  } else if(type === 'month') {
    timeRange = [moment(timeRangeInit?.[0]).subtract(0, 'month').startOf('month').format('YYY-MM-DD'),moment(timeRangeInit?.[1]).subtract(0, 'month').endOf('month').format('YYY-MM-DD')];
  }
  return timeRange;
};